import Rails from '@rails/ujs';
Rails.start();

import "../javascript/shared/page_icons";

import "../stylesheets/pages.scss";
